<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.code"
                 placeholder="商品编号"
                 style="width: 150px;"
                 @on-enter="searchFn"/>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.title"
                 placeholder="商品名称"
                 style="width: 150px;"
                 @on-enter="searchFn"/>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.typeId"
                  :label-in-value="true"
                  placeholder="类型"
                  class="select"
          >
            <Option v-for="(item,index) in apiData.producttypeList" :key="index" :value="item.id+''" :label="item.name">
            </Option>
          </Select>
        </div>
        <!-- <div class="search-item">
            <Select clearable
                style="width:100px;"
                v-model="search.tag"
                :label-in-value="true"
                placeholder="行业"
                class="select"
              >
             <Option v-for="(item,index) in apiData.productAllTag" :key="index" :value="item" :label="item"></Option>
            </Select>
        </div> -->
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.status"
                  :label-in-value="true"
                  placeholder="状态"
                  class="select"
          >
            <Option value="0" label="下架"></Option>
            <Option value="1" label="上架"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.secEnabel"
                  :label-in-value="true"
                  placeholder="秒杀"
                  class="select"
          >
            <Option value="0" label="非秒杀"></Option>
            <Option value="1" label="秒杀"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.standard"
                  :label-in-value="true"
                  placeholder="标品"
                  class="select"
          >
            <Option value="0" label="非标品"></Option>
            <Option value="1" label="标品"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.custom"
                  :label-in-value="true"
                  placeholder="定制品"
                  class="select"
          >
            <Option value="0" label="非定制"></Option>
            <Option value="1" label="定制"></Option>
          </Select>
        </div>
        <div class="search-item">
          <Select clearable
                  style="width:100px;"
                  v-model="search.skuEnabel"
                  :label-in-value="true"
                  placeholder="多规格"
                  class="select"
          >
            <Option value="0" label="非多规格"></Option>
            <Option value="1" label="多规格"></Option>
          </Select>
        </div>

        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
      </div>
      <div class="search-center">
        <Button
            style="width: 80px;"
            type="primary"
            @click="addPRoduct"
        >新增商品
        </Button>
      </div>
    </div>
    <div class="table">
      <Table
          ref="selection"
          @on-select="selectSupplier"
          @on-select-cancel="selectSupplier"
          @on-select-all="selectSupplier"
          @on-select-all-cancel="selectSupplier"
          :columns="diyData.columns"
          :data="apiData.tableList"
          @on-drag-drop="changeTableSort"
      >
        <template slot="footer">
          <div class="pagination">
          </div>
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
          ></Page>
        </template>
      </Table>
    </div>

  </div>
</template>

<script>
import {apiProducttypeAll} from '@/api/classification-manage.js'
import {
  apiProductAllTag,
  apiProductChangeSalestatus,
  apiProductDelete,
  apiProductDrag,
  apiProductList,
  apiProductMove
} from '@/api/product-manage.js'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'product-manage',
  components: {Treeselect},
  data() {
    return {
      search: {
        title: '',
        code: '',
        typeId: '',
        industryId: '',
        status: '',
        secEnabel: '',
        standard:  '',
        custom: '',
        skuEnabel: '',
        secPrice: '',
        pageNo: 1,
        pageSize: 10
      },
      diyDom: {
        showModal: false,
        type: 1// 1分类,2,标签,3,标记
      },
      diyData: {
        ids: '',
        orderNo: '',
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            title: '名称/编号',
            width: '200px',
            render: (h, params) => {
              const title = params.row.title || ''
              const code = params.row.code || ''

              return h('div', [
                h('p', title),
                code ? h('p', code) : ''
              ])
            }
          },
          {
            title: '图片',
            width: '100px',
            render: (h, params) => {
              return h('img', {
                attrs: {
                  src: params.row.img.split(',')[0]
                },
                style: {
                  width: '50px'
                }
              })
            }
          },
          {
            title: '类型',
            width: '100px',
            key: 'typeName'
          },
          // {
          //   title: '行业',
          //   width: '100px',
          //   key: 'industryName'
          // },
          {
            title: '价格',
            width: '100px',
            render: (h, params) => {
              var html = ''
              if (params.row.minPrice && params.row.maxPrice) {
                html = [h('p', params.row.minPrice + '-' + params.row.maxPrice)]
              } else if (params.row.minPrice && !params.row.maxPrice) {
                html = [h('p', params.row.minPrice)]
              } else {
                html = [h('p', params.row.price)]
              }
              return h('div', html)
            }
          },
          {
            title: '标品',
            width: '80px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.standard == 1 ? '是' : '否')
              ])
            }
          },
          {
            title: '定制品',
            width: '80px',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.custom == 1 ? '是' : '否')
              ])
            }
          },
          {
            title: '秒杀',
            width: '80px',
            key: 'secEnabel',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.secEnabel == 1 ? '是' : '否')
              ])
            }
          },
          {
            title: '多规格',
            width: '80px',
            key: 'secEnabel',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.skuEnabel == 1 ? '是' : '否')
              ])
            }
          },
          {
            title: '销量',
            width: '80px',
            key: 'sales'
          },
          {
            title: '模版数',
            width: '80px',
            key: 'num'
          },
          {
            title: '状态',
            width: '80px',
            key: 'status',
            render: (h, params) => {
              return h('div', [
                h('p', params.row.status == 1 ? '上架' : '下架')
              ])
            }
          },
          {
            title: '最后操作时间',
            width: '180px',
            key: 'createTime'
          },
          {
            title: ' '
          },
          {
            title: '操作',
            width: '200px',
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                      props: {
                        size: 'small'
                      },
                      style: {
                        marginRight: '10px',
                        fontSize: '14px'
                      },
                      on: {
                        click: () => {
                          sessionStorage.setItem('search', JSON.stringify(this.search))
                          this.$router.push({
                            name: 'show-price',
                            query: {
                              id: params.row.id
                            }
                          })
                        }
                      }
                    },
                    '查看'
                ),
                //        h(
                //   'Button',
                //   {
                //     style: {
                //       marginRight: '10px',
                //       color: '#383838',
                //     },
                //     on: {
                //       click: () => {
                //         var opt={
                //               id1:this.apiData.tableList[params.index-1>0?params.index-1:0].id,
                //               id2:params.row.id,
                //             }
                //             this.getProductProductMove(opt)
                //       }
                //     }
                //   },
                //   '上移'
                // ),
                // h(
                //   'Button',
                //   {
                //     style: {
                //       marginRight: '10px',
                //       color: '#383838',
                //     },
                //     on: {
                //       click: () => {
                //         console.log(params.index+1,this.search.pageSize,params.index+1> Number(this.search.pageSize),params.index+1>this.search.pageSize?params.index:params.index+1)
                //          var opt={
                //               id2:this.apiData.tableList[params.index+1>=Number(this.search.pageSize) ?params.index:params.index+1].id,
                //               id1:params.row.id,
                //             }
                //             this.getProductProductMove(opt)
                //       }
                //     }
                //   },
                //   '下移'
                // ),
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        infor: null,
        tableList: [],
        productAllTag: [],
        producttypeList: []
      }
    }
  },
  methods: {
    // 商品分类
    getProducttypeList() {
      apiProducttypeAll().then(res => {
        // var obj=[]
        // for(var i=0;i<res.data.length;i++){
        //     if(res.data[i].level==1){
        //         var data=res.data[i]
        //         data.children=[]
        //         data.label=res.data[i].name
        //         data.isEdit=false
        //         obj.push(data)
        //     }else{
        //         obj=obj.map(item=>{
        //             if(item.id==res.data[i].parentId){
        //                 var children=res.data[i]
        //                 children.isEdit=false
        //                 children.label=res.data[i].name
        //                 item.children.push(children)
        //             }
        //             return item
        //         })
        //     }

        // }
        // this.apiData.producttypeList=obj.map(item=>{
        //   if(item.children.length==0){
        //     delete item.children
        //   }
        //  return item
        // })
        this.apiData.producttypeList = res.data
      })
    },
    selectSupplier(e) {
      var ids = e.map(res => {
        return res.id
      })
      this.diyData.ids = ids.join(',')
      console.log(this.diyData.ids)
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    // 所有标签
    getProductAllTag() {
      apiProductAllTag().then(res => {
        this.apiData.productAllTag = res.data
      })
    },
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    addPRoduct() {
      this.$router.push({
        name: 'add-product'
      })
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = {...this.search}
      apiProductList(opt).then((res) => {
        const {
          list,
          totalCount
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    batchWarehous(i) {
      var that = this
      if (this.diyData.ids) {
        this.$Modal.confirm({
          title: '提示',
          content: `是否确认批量${i == 1 ? '上架' : '下架'}当前产品?`,
          onOk: () => {
            var opt = {
              ids: this.diyData.ids,
              saleStatus: i
            }
            apiProductSaleStatus(opt).then(res => {
              that.getTableList()
            })
          }
        })
      } else {
        this.$Modal.error({
          title: '系统提示',
          content: '请先选择产品'
        })
      }
    },

    getProductProductMove(opt) {
      apiProductMove(opt).then(res => {
        this.getTableList()
      })
    },
    changeTableSort(oldIndex, newIndex) {
      console.log(oldIndex, newIndex)
      var tableList = this.apiData.tableList
      var list = []
      if (oldIndex < newIndex) {
        for (var i = oldIndex; i <= newIndex; i++) {
          if (i == oldIndex) {
            var obj = {
              id: tableList[i].id,
              sort: Number(tableList[newIndex].sort)
            }
            list.push(obj)
          } else {
            var obj = {
              id: tableList[i].id,
              sort: Number(tableList[i].sort) - 1
            }
            list.push(obj)
          }
        }
      } else if (oldIndex > newIndex) {
        var obj = {
          id: tableList[oldIndex].id,
          sort: Number(tableList[newIndex].sort)
        }
        list.push(obj)
        for (var i = newIndex; i < oldIndex; i++) {
          if (i != oldIndex) {
            var obj = {
              id: tableList[i].id,
              sort: Number(tableList[i].sort) + 1
            }
            list.push(obj)
          }
        }
      }
      apiProductDrag({list: list}).then(res => {
        this.getTableList()
      })
    }

  },
  mounted() {
    var search = sessionStorage.getItem('search') || ''
    if (search) {
      this.search = JSON.parse(search)
      sessionStorage.removeItem('search')
    }
    this.getTableList()
    this.getProductAllTag()
    this.getProducttypeList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

.button-border {
  margin-right: 10px;

}

.tag {
  width: 50px;
  height: 26px;
  opacity: 1;
  border-radius: 5px;
  background: rgba(255, 87, 51, 1);
  text-align: center;
  line-height: 26px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-left: 10px;
  display: inline-block;
}
</style>
